import {emotionStyled} from '@packages/utilities/styled';
import {Link} from '../Link';
import {tokens} from '../../themes';

export const AccordionView = emotionStyled('div')(
  {},
  {componentName: 'Accordion'}
);

export const AccordionItemView = emotionStyled('div')(
  {},
  {componentName: 'AccordionItem'}
);

export const AccordionButtonView = emotionStyled(Link)(
  {
    alignItems: 'center',
    background: '$background1',
    color: '$textPrimary',
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    userSelect: 'none',
    '&:hover': {
      textDecoration: 'none',
    },
    '&:focus-visible': {
      textDecoration: 'none !important',
      outlineOffset: '-1px',
    },
  },
  {
    componentName: 'AccordionButton',
    variants: {
      density: {
        comfortable: {
          padding: tokens.ui.accordion.button.padding.comfortable,
        },
        compact: {
          padding: tokens.ui.accordion.button.padding.compact,
        },
      },
    },
  }
);

export const AccordionHeadingWrapperView = emotionStyled('div')(
  {
    position: 'relative',
  },
  {componentName: 'AccordionHeadingWrapper'}
);

export const AccordionHeadingView = emotionStyled('div')(
  {
    userSelect: 'none',
  },
  {componentName: 'AccordionHeading'}
);

export const AccordionAdornmentView = emotionStyled('div')(
  {
    position: 'absolute',
    right: tokens.ui.accordion.adornment.rightPosition,
    top: '50%',
    transform: 'translateY(-50%)',
    fontSize: 'initial',
    lineHeight: 'initial',
  },
  {componentName: 'AccordionAdornment'}
);

export const AccordionPanelView = emotionStyled('div')(
  {
    padding: '$1',
  },
  {
    variants: {
      isHidden: {
        true: {
          display: 'none',
        },
      },
    },
    componentName: 'AccordionPanel',
  }
);
